import BaseApi from '@core/api/model';

export class RestrictedPanelApi extends BaseApi {
    static resource = 'panels';
}

export default RestrictedPanelApi;
